module.exports = __webpack_public_path__ + "static/media/accessories.56ed32a4.svg";